import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";
import { CommonService } from "../service/common";
import { API } from "../config/api-config";

@Component({
  selector: "app-goal-task-edit",
  templateUrl: "./goal-task-edit.component.html",
  styleUrls: ["./goal-task-edit.component.css"],
})
export class GoalTaskEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public imagePath: string = "";

  public data: any = {
    active: 1,
    count: 0,
    titleEn: "",
    titleTc: "",
    id: 0,
    taskType: "JOIN_ACTIVITIES",
  };

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }

  public submit(): void {
    let data = this.data;
    console.log(data);
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.goalTaskEdit, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private getData(): void {
    this.HttpService.getData(API.goalTask + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/goal-task-edit/goal-task-edit.component.ts